"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCustomerFeedbackAggregableDataToCustomerFeedbackForDriver = transformCustomerFeedbackAggregableDataToCustomerFeedbackForDriver;
function transformCustomerFeedbackAggregableDataToCustomerFeedbackForDriver(aggregableData) {
    const result = [];
    aggregableData.forEach((ad) => {
        const customerFeedbackForDriver = {
            originLocationName: ad.originLocationName,
            destinationLocationName: ad.destinationLocationName,
            departureAt: ad.departureAt,
            text: ad.feedback.text,
            textScore: ad.feedback.textScore,
            locationNames: ad.locationNames,
        };
        result.push(customerFeedbackForDriver);
    });
    return result;
}
//# sourceMappingURL=transformCustomerFeedbackAggregableDataToCustomerFeedbackForDriver.js.map